/******************************************************************
 * Archivo : client/src/components/User/ChangePassword.js
 * Proyecto: CB30
 * Módulo  : Usuarios
 * Proceso : Cambio obligatorio de contraseña
 ******************************************************************/

import React, { Component } from "react";
import { graphql } from "react-apollo";

// Mutation
import changePassword from "../../mutations/changePassword";

class ChangePassword extends Component {

  state = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    msg: "",
    error: ""
  };

  handleChange = e => {

    const { name, value } = e.target;

    this.setState({
      [name]: value,
      error: "",
      msg: ""
    });

  };

  handleSubmit = async e => {

    e.preventDefault();

    const {
      currentPassword,
      newPassword,
      confirmPassword
    } = this.state;

    if (!currentPassword || !newPassword || !confirmPassword) {

      this.setState({
        error: "Todos los campos son obligatorios."
      });

      return;
    }

    if (newPassword !== confirmPassword) {

      this.setState({
        error: "Las contraseñas nuevas no coinciden."
      });

      return;
    }

    try {

      await this.props.changePassword({

        variables: {
          currentPassword,
          newPassword,
          confirmPassword
        }

      });

      this.setState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        msg: "Contraseña cambiada correctamente.",
        error: ""
      });

      setTimeout(() => {

        this.props.history.push("/dashboard");

      }, 1500);

    } catch (err) {

      console.error("ERROR CHANGE PASSWORD:", err);

      this.setState({
        error:
          err.graphQLErrors && err.graphQLErrors.length
            ? err.graphQLErrors[0].message
            : "No fue posible cambiar la contraseña.",
        msg: ""
      });

    }

  };

  render() {

    return (

      <div className="container">

        <div className="row justify-content-center">

          <div className="col-md-6">

            <h2 className="text-center">
              Cambiar contraseña
            </h2>

            <p className="text-muted text-center">
              Por seguridad debes cambiar tu contraseña temporal
              antes de continuar.
            </p>

            <form onSubmit={this.handleSubmit}>

              <div className="form-group">

                <label>
                  Contraseña actual
                </label>

                <input
                  type="password"
                  name="currentPassword"
                  value={this.state.currentPassword}
                  onChange={this.handleChange}
                  className="form-control"
                  autoComplete="current-password"
                />

              </div>

              <div className="form-group">

                <label>
                  Nueva contraseña
                </label>

                <input
                  type="password"
                  name="newPassword"
                  value={this.state.newPassword}
                  onChange={this.handleChange}
                  className="form-control"
                  autoComplete="new-password"
                />

              </div>

              <div className="form-group">

                <label>
                  Confirmar nueva contraseña
                </label>

                <input
                  type="password"
                  name="confirmPassword"
                  value={this.state.confirmPassword}
                  onChange={this.handleChange}
                  className="form-control"
                  autoComplete="new-password"
                />

              </div>

              {this.state.error !== "" && (

                <div className="alert alert-danger">
                  {this.state.error}
                </div>

              )}

              {this.state.msg !== "" && (

                <div className="alert alert-success">
                  {this.state.msg}
                </div>

              )}

              <button
                type="submit"
                className="btn btn-primary btn-block"
              >
                Cambiar contraseña
              </button>

            </form>

          </div>

        </div>

      </div>

    );

  }

}

export default graphql(changePassword, {
  name: "changePassword"
})(ChangePassword);


// WEBPACK FOOTER //
// ./src/components/User/ChangePassword.js